export default __webpack_public_path__ + "static/media/Kathryn 9781408333945.09e7bfca.jpg";